import { communicationService, utils } from '@wikia/ad-engine';
import { PLATFORM_EXPLORE_NAVIGATION_TOGGLE } from '../../../communication/events/events-platform-explore-navigation-toggle';

const initialOpenedRailClassName = 'current-wiki-tab-open';
const exploreNavigationExpandedClassName = 'explore-navigation-expanded';

export class ExploreNavigationHandler {
	async init(): Promise<void> {
		await this.waitForExploreNavigationOnPageLoad()
			.until()
			.then(() => {
				this.setExploreNavigationListener();
				this.setResizeListener();
			});
	}

	private checkCssClassOnDom(): boolean {
		return document.documentElement.classList.contains(initialOpenedRailClassName);
	}

	private getTopLeaderboard(): HTMLElement | null {
		return document.getElementById('top_leaderboard');
	}

	private setExploreNavigationListener(): void {
		communicationService.on(
			PLATFORM_EXPLORE_NAVIGATION_TOGGLE,
			async (event) => {
				this.toggleNavigationClassName(event.isOpened);
				const interval = setInterval(() => {
					window.dispatchEvent(new CustomEvent('resize', { detail: 'self triggered' }));
				}, 20);
				setTimeout(() => {
					clearInterval(interval);
				}, 350);
			},
			false,
		);
	}

	private setResizeListener(): void {
		window.addEventListener('resize', ({ detail }): void => {
			// @ts-ignore TS treats event here as UIEvent not CustomEvent and infers detail type as a number
			if (detail === 'self triggered') return;
			if (!this.checkCssClassOnDom()) {
				this.toggleNavigationClassName(false);
			}
		});
	}

	private waitForExploreNavigationOnPageLoad() {
		return new utils.WaitFor(() => this.checkCssClassOnDom(), 20, 0, 50);
	}

	private toggleNavigationClassName(isOpened: boolean): void {
		const tlb = this.getTopLeaderboard();
		tlb?.classList.toggle(exploreNavigationExpandedClassName, isOpened);
	}
}

export const exploreNavigationHandler = new ExploreNavigationHandler();
